import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import usePayment from 'hooks/usePayment';
import VIButton from 'general/components/VietInvoice/VIButton';

ConfirmPaymentStep2Info.propTypes = {
  onPressEdit: PropTypes.func,
};

ConfirmPaymentStep2Info.defaultProps = {
  onPressEdit: null,
};

/**
 *
 * @param {{
 * onPressEdit: function,
 * }} props
 * @returns
 */
function ConfirmPaymentStep2Info(props) {
  // ---- params ----
  const { onPressEdit } = props;
  const { t } = useTranslation();
  const { confirmPaymentInfo } = usePayment();

  // ---- methods ----
  function handleEdit() {
    if (onPressEdit) {
      onPressEdit();
    }
  }

  return (
    <div
      className="bg-white p-6"
      style={{
        borderRadius: '16px',
        border: '1px solid #E8E9EB',
      }}
    >
      <div className="">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <i
              className="fa-regular fa-file-invoice-dollar text-primary"
              style={{
                fontSize: '24px',
              }}
            />
            <span className="font-weight-bolder text-grey font-size-lg">
              Thông tin cấp hoá đơn tài chính
            </span>
          </div>

          <VIButton
            text={t('Edit')}
            className="btn-grey"
            style={{ padding: '8px' }}
            onClick={handleEdit}
            beforeIcon={<i className="fa-regular fa-edit" />}
          />
        </div>

        <div className="d-flex mt-3">
          <div className="mr-4 d-flex flex-column gap-2">
            <p className="m-0">{t('Fullname')}:</p>
            <p className="m-0">{t('PhoneNumber')}:</p>
            <p className="m-0">{t('Email')}:</p>
            <p className="m-0">{t('Address')}:</p>
          </div>
          <div className="d-flex flex-column gap-2">
            <p className="font-weight-bold m-0">{confirmPaymentInfo.invoiceInfoName}&nbsp;</p>
            <p className="font-weight-bold m-0">{confirmPaymentInfo.invoiceInfoPhone}&nbsp;</p>
            <p className="font-weight-bold m-0">{confirmPaymentInfo.invoiceInfoEmail}&nbsp;</p>
            <p className="font-weight-bold m-0">{confirmPaymentInfo.invoiceInfoAddress}&nbsp;</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmPaymentStep2Info;
